import { render, staticRenderFns } from "./IconInHospital.vue?vue&type=template&id=4843a63b"
import script from "./IconInHospital.vue?vue&type=script&lang=js"
export * from "./IconInHospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports